/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
const dependencies = [
  '$scope', 'EntityManager', 'FilterParamsService', 'EmployeeEmail', 'emailStatus', 'packageTypeService'
];

const SecurityManagerHrEmailDraftsController = function(
  $scope, EntityManager, FilterParamsService, EmployeeEmail, emailStatus, packageTypeService
) {

  const vm = this;

  const EMAIL_STATUS_DRAFT = emailStatus.getDraftStatus();

  const entityManager = new EntityManager(EmployeeEmail, {
    queryParams: {
      status: EMAIL_STATUS_DRAFT
    }
  });

  const filterParamsService = new FilterParamsService({
    filter: ['searchString']
  });

  vm.filterParams = filterParamsService.getParams();

  vm.isDisabledLoading = entityManager.isDisabledLoading;

  vm.$onInit = function () {
    packageTypeService.checkProPackage();
  };

  vm.getEmails = function () {
    return entityManager.entities;
  };

  vm.loadMoreEmployeeEmails = function () {
    return entityManager.loadMore();
  };

  vm.showEmployeeEmailPopup = function() {
    vm.popupEmployeeEmail = entityManager.createEntity();
    vm.isShownEmailPopup = true;
  };

  vm.closeEmployeeEmailPopup = function(employeeEmail) {
    let existingEmployeeEmail;
    closePopup();
    if ((employeeEmail != null ? employeeEmail.status : undefined) === EMAIL_STATUS_DRAFT) {
      existingEmployeeEmail = entityManager.findEntity(employeeEmail);
      if (existingEmployeeEmail) {
        angular.copy(employeeEmail, existingEmployeeEmail);
        existingEmployeeEmail.formattedDate = null;
      } else {
        entityManager.unshiftEntity(employeeEmail);
        $scope.securityManagerHrCtrl.increaseDraftsCount();
      }
    } else if ((employeeEmail != null ? employeeEmail.status : undefined) === emailStatus.getSentStatus()) {
      existingEmployeeEmail = entityManager.findEntity(employeeEmail);
      if (existingEmployeeEmail) {
        entityManager._removeEntity(existingEmployeeEmail);
        $scope.securityManagerHrCtrl.deceaseDraftsCount();
      }
    }
  };

  vm.editEmail = function(email) {
    vm.popupEmployeeEmail = email;
    vm.isShownEmailPopup = true;
  };

  vm.removeEmployeeEmail = function () {
    return $scope.$apply(() =>
      entityManager.removeEntity(vm.popupEmployeeEmail, function () {
        closePopup();
        $scope.securityManagerHrCtrl.deceaseDraftsCount();
      })
    );
  };

  const closePopup = function() {
    vm.popupEmployeeEmail = null;
    vm.isShownEmailPopup = false;
  };

  const filterEmployeeEmails = function() {
    entityManager.resetLoadData();
    const urlParams = filterParamsService.getFilterUrlParams();
    return entityManager.load(urlParams);
  };

  $scope.$watch(function () {
    return vm.filterParams;
  }, _.debounce(filterEmployeeEmails, 50), true);

  return vm;

};

angular.module('public.security-manager.hr.email').controller('SecurityManagerHrEmailDraftsController',
  dependencies.concat(SecurityManagerHrEmailDraftsController));
